import axios from 'axios';
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { useNavigate, useParams } from 'react-router';
import Swal from 'sweetalert2';
import DataTable from '../components/DataTable';
const moment = require('moment');

const ListarContratos = () => {
  const { id } = useParams();
  const [contratos, setContratos] = useState([]);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  // Eliminar contrato
  const deleteContrato = async (idContrato) => {
    try {
      Swal.fire({
        title: '¿Está seguro?',
        text: '¡No podrá revertir este proceso!',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Sí, eliminar',
        cancelButtonText: 'Cancelar',
      }).then(async (result) => {
        if (result.isConfirmed) {
          await axios.delete(`/api/contratos/delete/${idContrato}`);
          await getData(); // refrescar
          Swal.fire({
            icon: 'success',
            title: 'Contrato eliminado correctamente',
            showConfirmButton: false,
            timer: 1500,
          });
        }
      });
    } catch (error) {
      console.error('Error al eliminar el contrato:', error);
      Swal.fire('Error', error.response?.data?.message || 'No se pudo eliminar el contrato', 'error');
    }
  };

  // Obtener datos
  const getData = useCallback(async () => {
    try {
      setLoading(true);
      const res = await axios.get(`/api/contratos/listbyinstructor/${id}`);

      if (res.data.ok) {
        const dataConItem = (res.data.contratos || []).map((contrato, index) => ({
          item: index + 1,
          _id: contrato._id,
          numeroContrato: contrato.contrato,

          fechaInicio: contrato.fechaInicio
            ? moment.utc(contrato.fechaInicio).add(5, 'hours').format('DD/MM/YYYY')
            : '-',

          fechaFin: contrato.fechaFin
            ? moment.utc(contrato.fechaFin).add(5, 'hours').format('DD/MM/YYYY')
            : '-',

          valorContrato: `$${Number(contrato.valorContrato || 0).toLocaleString('es-CO')}`,
          estado: contrato.estado || '-',
          entidadContratante: contrato.regional?.nombreRegional || '-',
          centroFormacion: contrato.centroFormacion?.nombreCentro || '-',
          nombreInstructor: contrato.instructorNombreCompleto || '-',
          documentoInstructor: contrato.instructor?.documentoInstructor || '-',

          funciones: (
            <div className="d-flex gap-2 flex-wrap justify-content-end">
              {/* Agendas */}
              <button
                className="btn btn-dark btn-sm d-inline-flex align-items-center justify-content-center"
                style={{ width: 34, height: 34 }}
                onClick={() =>
                  navigate(`/instructor/agendas/${contrato._id}`, {
                    state: { contrato },
                  })
                }
                title="Agendas de Viaje"
                type="button"
              >
                <i className="fa-solid fa-plane"></i>
              </button>


              {/* Listar informes */}
              <button
                className="btn btn-outline-dark btn-sm d-inline-flex align-items-center justify-content-center"
                style={{ width: 34, height: 34 }}
                onClick={() => navigate(`/instructor/informecontractual/listar/${contrato._id}`)}
                title="Listar Informes Contractuales"
                type="button"
              >
                <i className="fa-solid fa-list-check"></i>
              </button>

              {/* Informe */}
              <button
                className="btn btn-dark btn-sm d-inline-flex align-items-center justify-content-center"
                style={{ width: 34, height: 34 }}
                onClick={() => navigate(`/instructor/informecontractual/${contrato._id}`)}
                title="Informe Contractual"
                type="button"
              >
                <i className="fa-solid fa-clipboard-check"></i>
              </button>

              {/* Obligaciones */}
              <button
                className="btn btn-outline-secondary btn-sm d-inline-flex align-items-center justify-content-center"
                style={{ width: 34, height: 34 }}
                onClick={() => navigate(`/instructor/obligaciones/${contrato._id}`)}
                title="Obligaciones Contractuales"
                type="button"
              >
                <i className="fa-solid fa-clipboard-list"></i>
              </button>

              {/* Editar */}
              <button
                className="btn btn-warning btn-sm d-inline-flex align-items-center justify-content-center"
                style={{ width: 34, height: 34 }}
                onClick={() =>
                  navigate(`/instructor/registrarcontratos/editar/${contrato._id}`, {
                    state: { contrato },
                  })
                }
                title="Editar Contrato"
                type="button"
              >
                <i className="fa-solid fa-pen-to-square"></i>
              </button>

              {/* Eliminar */}
              <button
                className="btn btn-danger btn-sm d-inline-flex align-items-center justify-content-center"
                style={{ width: 34, height: 34 }}
                onClick={() => deleteContrato(contrato._id)}
                title="Eliminar Contrato"
                type="button"
              >
                <i className="fa-solid fa-trash"></i>
              </button>
            </div>
          ),
        }));

        setContratos(dataConItem);
      } else {
        setContratos([]);
      }
    } catch (error) {
      console.error('Error al obtener contratos:', error);
      setContratos([]);
    } finally {
      setLoading(false);
    }
    // eslint-disable-next-line
  }, [id]);

  useEffect(() => {
    getData();
  }, [getData]);

  const columns = useMemo(
    () => [
      { Header: 'Item', accessor: 'item' },
      { Header: 'N° Contrato', accessor: 'numeroContrato' },
      { Header: 'Inicio', accessor: 'fechaInicio' },
      { Header: 'Fin', accessor: 'fechaFin' },
      { Header: 'Valor ($)', accessor: 'valorContrato' },
      { Header: 'Estado', accessor: 'estado' },
      { Header: 'Entidad', accessor: 'entidadContratante' },
      {
        Header: 'Centro de Formación',
        accessor: 'centroFormacion',
        width: 280,
        hideHeaderOnMobile: true,
      },
      { accessor: 'funciones' },
    ],
    []
  );

  return (
    <div>
      <div className="container-fluid px-2 px-md-4">
        <div className="bg-white border rounded-4 shadow-sm overflow-hidden">
          {/* Header */}
          <div className="px-3 px-md-4 py-3 border-bottom bg-white">
            <div className="d-flex justify-content-between align-items-start flex-wrap gap-3">
              <div>
                <h5 className="mt-2 mb-1 fw-semibold">Contratos del instructor</h5>
                <small className="text-secondary">
                  Gestión contractual, informes y obligaciones asociadas.
                </small>
              </div>

              <div className="d-flex gap-2 flex-wrap">
                <button
                  className="btn btn-outline-secondary"
                  type="button"
                  onClick={() => navigate(-1)}
                  title="Volver"
                >
                  <i className="fa-solid fa-arrow-rotate-left me-2"></i>

                  Volver
                </button>

                <button
                  className="btn btn-outline-secondary"
                  type="button"
                  onClick={() => getData()}
                  title="Actualizar"
                  disabled={loading}
                >
                  <i className={`fa-solid ${loading ? 'fa-spinner fa-spin' : 'fa-rotate'} me-2`}></i>
                  Actualizar
                </button>
              </div>
            </div>
          </div>

          {/* Body */}
          <div>
            {loading ? (
              <div className="text-center text-secondary py-5">
                <div className="spinner-border" role="status" aria-hidden="true"></div>
                <div className="mt-3">Cargando contratos…</div>
              </div>
            ) : Array.isArray(contratos) && contratos.length > 0 ? (
              <div className="overflow-hidden">
                <DataTable columns={columns} data={contratos} />
              </div>
            ) : (
              <div className="text-center text-secondary py-5">
                <div className="display-6 mb-2">🐾</div>
                <div className="fw-semibold">No hay contratos registrados</div>
                <div className="small">Aún no existen contratos asociados a este instructor.</div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ListarContratos;
